$(function () {
    // Use this variable to avoid using unsupported elements, etc. in IE8 and lower
    var isLtIE9 = $('html').hasClass('ie');


    // RegEx for extracting filename from url (use array position [0])
    var url = window.location.href;
    var filename = url.match(/([^\/]+)(?=\.\w+$)/);
    var linkIdRegEx = /#([A-Za-z0-9-]+)/;

    // Setup tab behavior for elements
    $('.quicklinks').tabs({
        show: 'fadeIn',
        hide: 'fadeOut'
    });


    // Galleries - Images and videos
    $('.gallery .viewport').cycle({
        timeout : 0,
        fx      : 'scrollHorz',
        easing  : 'easeOutCubic',
        pager   : '.thumbnails',
        pagerAnchorBuilder: function(idx, slide) {
            // return selector string for existing anchor
            return '.thumbnails img:eq(' + idx + ')';
        }
    });

    // Change viewport video
    $('.tutorials .listings').click(function (event) {

        var elem = $(event.target);

        if ( $(elem).is('a') || $(elem).is('a > span') ) {
            $('.viewport .video').fadeOut('slow', function() {
                $(this).remove();
                $('.showing').removeClass('showing');
                $(elem).closest('li').addClass('showing').find('a').clone().appendTo('.viewport');
                $('.viewport .video').media({
                    width       : 680,
                    height      : 386,
                    caption     : false,
                    flashvars   : { autostart   : 'true' },
                    params      : {
                        allowfullscreen     : 'true',
                        allowscriptaccess   : 'always'
                    }
                });
                $('.viewport .video').hide().fadeIn('slow');
            });
            return false; } });

    $('.tutorials .tutorialList li').click(function (event) {
        var elem = $(event.target);
        var url = $(event.target).attr('data-url');
        console.log('url = ' + url);
        $('.viewport video').fadeOut('slow', function() {
            //$(this).remove();
            $('.viewport video source').attr('src', url);
            $('.viewport video')[0].load();
            $('.showing').removeClass('showing');
            $(elem).addClass('showing');
            $('.viewport video').hide().fadeIn('slow');
        })
    });


    // Aim Assist Demonstration
    var aimAssistDemo = function () {
        // Make the Aim Assist button blink
        var aimAssistButtonBlink;

        // aimAssist flashing function
        function aimAssistBlink() {
            aimAssistButtonBlink = setInterval(function () {
                    $('.aim-assist-demo').toggleClass('aim-assist-waiting');
              }, 500);
        }
        function aimAssistStopBlink() {
            clearInterval(aimAssistButtonBlink);
        }

        // Activate/deactivate the Aim Assist
        $('.aim-assist-button').click(function () {
            if ( $(this).closest('.aim-assist-demo').hasClass('aim-assist-activated') ) {
                $(this).closest('.aim-assist-demo').removeClass('aim-assist-activated');
                aimAssistBlink();
            } else {
                aimAssistStopBlink();
                $(this).closest('.aim-assist-demo').removeClass('aim-assist-waiting').addClass('aim-assist-activated');
            }
            return false;
        });

        // inits the aimAssist flashing
        aimAssistBlink();
    };
    aimAssistDemo();


    // Show/hide image processing modes
    // TODO: Migrate the elements that use this code to "Segmented controls" below
    $('span.mode').click(function () {
        if ( $(this).hasClass('active') ) {
            return false; }
        else {
            $('img.mode.active').fadeOut();
            $('span.mode').removeClass('active');
            $(this).addClass('active');

            if ( $(this).hasClass('grayscale') ) {
                $('img.mode.grayscale').addClass('active').fadeIn();
            }

            if ( $(this).hasClass('object') ) {
                $('img.mode.object').addClass('active').fadeIn();
            }

            if ( $(this).hasClass('segment') ) {
                $('img.mode.segment').addClass('active').fadeIn();
            }
        }
    });
    // Show/hide image range tests
    // TODO: Migrate the elements that use this code to "Segmented controls" below
    $('span.range.test').click(function () {
        if ( $(this).hasClass('active') ) {
            return false; }
        else {
            $('div.range.test.active').fadeOut();
            $('span.range.test').removeClass('active');
            $(this).addClass('active');

            if ( $(this).hasClass('_50') ) {
                $('div.range.test._50').addClass('active').fadeIn();
            }

            if ( $(this).hasClass('_75') ) {
                $('div.range.test._75').addClass('active').fadeIn();
            }

            if ( $(this).hasClass('_100') ) {
                $('div.range.test._100').addClass('active').fadeIn();
            }
        }
    });
    // Segmented controls
    $('.segmented-control-options .segmented-control-option').click(function () {
        var index = $(this).index();

        if ( $(this).hasClass('active') ) {
            return false;
        } else {
            // Hide old option
            $(this).closest('.segmented-control').find('.segmented-control-results .active').removeClass('active').addClass('hide');
            $(this).closest('.segmented-control').find('.active').removeClass('active');

            // Show new option
            $(this).addClass('active').removeClass('hide');
            $(this).closest('.segmented-control').find('.segmented-control-results').children().eq(index).addClass('active').removeClass('hide');
        }
    });


    // Regular Expression for extracing prices from options
    var priceRegEx = /[0-9]+(?=\))/;


    // Slim 3U Buy page
    function swapButtons(elem) {
        var selectedClass = $(elem).attr('class');

        $(elem).closest('.choice').find('.filter').addClass('hide');
        $(elem).closest('.choice').find('.filter.' + selectedClass).removeClass('hide');
    }

    function updateChoicePrice(elem, bundleID) {
        var bundleID = '#' + bundleID;
        var priceToFormat = $(bundleID).find('.price .format');
        var newPrice = $(elem).attr('data-bundlePrice');

        $(bundleID).find('.price').fadeOut(function () {
            $(priceToFormat).text(newPrice);
            $(priceToFormat).formatCurrency({ 'roundToDecimalPlace' : 0 });
            $(this).fadeIn();
        });
    }

    function evaluateOptions(elem) {
        var bundleID = $(elem).closest('.choice').attr('id');

        swapButtons(elem);
        updateChoicePrice(elem, bundleID);
        updatePriceDifference();
    }

    function updatePriceDifference() {
        $('.choice').each(function () {
            var selectedPrice = $(this).find('.options input:checked').attr('data-bundlePrice');

            $(this).find('.options input').each(function () {
                var optionPrice = $(this).attr('data-bundlePrice');
                var priceDifference = optionPrice-selectedPrice;

                if (priceDifference < 0 ) {
                    priceDifference = Math.abs(priceDifference);
                    $(this).siblings('label').find('.difference').text('[Sub. $' + priceDifference + ']');
                }
                else if (priceDifference === 0 ) {
                    $(this).siblings('label').find('.difference').text('');
                }
                else {
                    $(this).siblings('label').find('.difference').text('[Add $' + priceDifference + ']');
                }
            });
        });
    }

    updatePriceDifference();

    $('.options input').click(function () {
        evaluateOptions(this);
    });

    $('.v120slim.buy .choice .action a').click(function (event) {
        if ( !event.isImmediatePropagationStopped() ) {
            var addCartLink = $(this).attr('href');
            var quantityField = $(this).siblings('.quantity').val();
            window.location = addCartLink + quantityField;
            return false;
        }
    });


    // [end] Slim 3U stuff


    // ************  Marker Sets  ************




    // ************ [end] Marker Sets  ************

    // Update prices on Insight VCS Buy Page
    var vcsProPrice = Number( $('.vcs.pro .price').attr('title') );

    $('.vcs.pro form .option input').change(function () {
        var selectedOption = $(this).siblings('label').text();
        var optionPrice = Number( priceRegEx.exec(selectedOption) );
        var newVcsProPrice = vcsProPrice + optionPrice;

        $('.vcs.pro .price .format').text(newVcsProPrice);
        $('.vcs.pro .price .format').formatCurrency({'roundToDecimalPlace' : 0 });
    });


    // Dynamically load Bundle contents (AJAX)
    $('.bundles .choice').click(function () {
        var loadUrl = $(this).find('a').attr('href');

        $('.current.choice').removeClass('current');
        $(this).addClass('current');

        $('#dynamicContent').load(loadUrl + ' .configure.bundle', function () {
            $(this).slideDown();
        });

        return false;
    });


    // Pause slideshow when pager is clicked
    $('.pager').click(function () {
        $('.cycle').cycle('pause');
    });


    // Update part numbers on Buy Now pages for products with options
    var updatePartNumbers = function () {
        if ($('.buy.product .option').length > 0) {
            var compiledPartNumber = $('.main.photo span[data-part-number]').attr('data-part-number');

            $('.option input:checked').each(function () {
                var optionPartNumber = $(this).siblings('label').find('.option-part-number').attr('data-part-number');

                if (typeof optionPartNumber !== 'undefined') {
                    compiledPartNumber += "." + optionPartNumber;
                }
            });
            $('.main.photo span[data-part-number]').text(compiledPartNumber);
        }
    };
    $('.option').change(function () {
        updatePartNumbers();
    }).change();


    // TEMP: Change 'coming soon' to 'contact us' on active accessories and controllers pages.
    // Remove/update this script when 'coming soon' status is changed in store DB.
    $("#active-components .product .button, #controllers .product .button, .buyFieldSetWrapper .button span:contains('Coming soon')").each(function () {
        $(this).replaceWith('<a href="/contact/" class="button"><span>Contact Us</span></a>');
    });

    // Toggle class name for CSS transition to disclose new features in latest software releases.
    $('.toggleNewFeatures').click(function () {
        $('html').toggleClass('whatsNewOn');
        if ( $('html').hasClass('whatsNewOn') ) {
            //$('#whats-new-video').get(0).play(); /* Auto plays video about new motive features */
        } else {
            //$('#whats-new-video').get(0).pause(); /* Pauses video about new motive features */
        }
        // event.preventDefault();
    });

    /* lightbox */
    $(document).ready(function() {
        $('.lightbox-single-light').magnificPopup({type:'image', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade lightTheme'});

        $('.lightbox-gallery-light').magnificPopup({type: 'image', delegate: 'a', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade lightTheme', gallery:{enabled:true}});

        $('.lightbox-gallery-light-two').magnificPopup({type: 'image', delegate: 'a', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade lightTheme', gallery:{enabled:true}});

        $('.lightbox-gallery-light-three').magnificPopup({type: 'image', delegate: 'a', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade lightTheme', gallery:{enabled:true}});

        $('.lightbox-gallery-light-four').magnificPopup({type: 'image', delegate: 'a', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade lightTheme', gallery:{enabled:true}});

        $('.lightbox-video').magnificPopup({type:'iframe', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade'});

        $('.lightbox-video-two').magnificPopup({type:'iframe', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade'});

    });

    // *******************************************************************
    // Onload behavior
    // *******************************************************************
    $(window).on('load', function () {

        // Show what's new in Motive section on page load
        var hash = window.location.hash;

        if ( hash === '#new' ) {
            $('html').addClass('whatsNewOn')
        }


        // Default slideshow
        $('.cycle').not('.bundles .cycle').cycle({
            cleartypeNoBg : true,
            timeout       : 5000,
            speed         : 500,
            pager         : '.pager',
            pagerAnchorBuilder: function(idx, slide) {
                // return selector string for existing anchor
                return '.pager span:eq(' + idx + ')';
            }
        });



        // Check SLIM Buy Now options and update prices if needed - For refreshing pages in Firefox
        $('.fs.option input:checkbox').each(function () {
            checkOptions(this);
        });


        // Behavior for available bundle choices
        if ( $('.bundles .cycle').length > 0 ) {

            var chosenCamera = linkIdRegEx.exec(url);
            var cameraCount = $.getUrlVar('bundle');
            var startSlide; // Currently defaults to Flex 13 (see below)
            var chosenBundle;

            if (chosenCamera !== null) {
                // Find ID of matching camera count
                $('.' + chosenCamera[1] + '.slide .choice').each(function () {
                    if ( $(this).find('h4 .huge').text() === cameraCount ) {
                        chosenBundle = $(this).closest('.choice').attr('id');
                        return false;
                    }
                });
                // Check availability of specified camera count
                if ( chosenBundle === undefined ) {
                    if ( $('.' + chosenCamera[1] + '.slide').length > 0 ) {
                        $('.' + chosenCamera[1] + '.slide .default.choice').click();
                        // Set starting slide according to camera name
                        startSlide = $('.choices .' + chosenCamera[1] + '.slide').index();
                    }
                    else {
                        $('.flex13.slide .default.choice').click();
                        startSlide = 1;
                    }
                }
                else {
                    $('#' + chosenBundle).click();
                    // Set starting slide according to camera name
                    startSlide = $('.choices .' + chosenCamera[1] + '.slide').index();
                }
            }
            else {
                // Setup default default bundle choice if none specified in url
                $('.flex13.slide .default.choice').click();
                startSlide = 1;
            }

            // Setup cycle/carousel behavior
            $('.bundles .cycle').cycle({
                timeout         : 0,
                fx              : 'scrollHorz',
                easing          : 'easeOutCubic',
                pager           : '.pager',
                startingSlide   : startSlide,
                pagerAnchorBuilder: function(idx, slide) {
                    // return selector string for existing anchor
                    return '.pager > span:eq(' + idx + ')';
                }
            });
        }


        // Display Mocap Bundles in quicklinks on Buy Now page load
        if (filename !== null && filename[0] === 'buy') {
            $('a[href*="mocapBundles"]').click(); }


        // Flex 13 & V100:R2 Customize and Buy page
        var changeProductColor = function () {
            if ( $('.buy .option li label:contains("Red")').prev('input:checked').length > 0 ) {
                $('.main.photo img.black').hide();
                $('.main.photo img.red').show();
            }
            if ( $('.buy .option li label:contains("Black")').prev('input:checked').length > 0 ) {
                $('.main.photo img.black').show();
                $('.main.photo img.red').hide();
            }
        };

        $('.flex13.buy form.add input, .v100r2.buy form.add input').click(function () {
            changeProductColor();
        });

        changeProductColor();
    });
});
